import { LazyLoad } from 'app/utils';

export const UserTagListPage = LazyLoad(
  () => import('./index'),
  (module) => module.UserTagListPage,
);
